import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

export const PREFIX_FORM = 'ChangePassword';
export const CHANGE_PASSWORD = 'change-password';

export const VALIDATION_FIELDS_CHANGE_PASSWORD = [
    VALIDATION_FIELDS.oldPassword,
    VALIDATION_FIELDS.password,
    VALIDATION_FIELDS.confirmPassword
];
